module.exports = __webpack_public_path__ + "static/media/train11-1.13b89c56.png";